/**
 * Maps two arrays to an object key-value, and runs
 * modulus on values array if it is shorter than the key array
 * @param  {array} keys     Array of values that should be the keys
 * @param  {array} values   Array of values that should map to values
 * @return {object}         key-value object
 */
export default function modZip(keys, values) {
  return keys.reduce((acc, key, idx) => {
    const valKey = (idx < values.length) ? idx : idx % values.length;
    return { ...acc, [key]: values[valKey] };
  }, {});
}



// WEBPACK FOOTER //
// ./app/utils/array/modZip.js